module.exports = __webpack_public_path__ + "static/media/abstract3.c1d003b1.jpg";